"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

var _partUploadResult = _interopRequireDefault(require("./part-upload-result"));

var _utils = require("./utils");

var _httpRequest = _interopRequireDefault(require("./http/http-request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Has the responsibility of uploading file parts using HTTP. The uploader
 * has a centralized queue, to which additional parts can be added. The
 * uploader will ensure that a maximum number of parts from this queue
 * are continuously being uploaded concurrently.
 *
 * The uploader will use a FileTransferHandler to provide updates as parts
 * transfer.
 */
var PartUploader = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(PartUploader, _UploadOptionsBase);

  var _super = _createSuper(PartUploader);

  /**
   * Constructs a new uploader with the given dependencies.
   *
   * @param {object} options General direct upload options.
   * @param {DirectBinaryUploadOptions} uploadOptions Options for the current
   *  upload.
   * @param {HttpClient} httpClient Will be used to upload parts that are
   *  provided to the uploader.
   * @param {ConcurrentQueue} concurrentQueue Queue that the uploader will use
   *  to concurrently upload parts, if configured to do so via the upload options.
   */
  function PartUploader(options, uploadOptions, httpClient, concurrentQueue) {
    var _this;

    _classCallCheck(this, PartUploader);

    _this = _super.call(this, options, uploadOptions);
    _this.httpClient = httpClient;
    _this.concurrentQueue = concurrentQueue;
    return _this;
  }
  /**
   * Adds the given parts to the uploader's queue, which will ensure that a maximum
   * number of parts are continuously being uploaded simultaneously. Use the class's
   * events to determine individual file status and upload progress.
   *
   * @param {UploadResult} uploadResult Results of each part upload will be added to
   *  this result.
   * @param {Array} parts A list of InitResponseFilePart instances, which will be
   *  added to the upload queue.
   * @param {FileTransferHandler} fileTransferHandler Will be used to provide updates
   *  on the transfer progress of a file.
   */


  _createClass(PartUploader, [{
    key: "uploadParts",
    value: function () {
      var _uploadParts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uploadResult, parts, fileTransferHandler) {
        var _this2 = this;

        var concurrent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                concurrent = this.getUploadOptions().isConcurrent();

                if (!concurrent) {
                  _context.next = 7;
                  break;
                }

                this.logInfo("Concurrently uploading ".concat(parts.length, " total parts with a max count of ").concat(this.getUploadOptions().getMaxConcurrent()));
                _context.next = 5;
                return this.concurrentQueue.pushAll(parts, function (part) {
                  return _this2.processPart(uploadResult, part, fileTransferHandler);
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                this.logInfo("Serially uploading ".concat(parts.length, " total parts"));
                _context.next = 10;
                return (0, _utils.serialLoop)(parts, function (part) {
                  return _this2.processPart(uploadResult, part, fileTransferHandler);
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadParts(_x, _x2, _x3) {
        return _uploadParts.apply(this, arguments);
      }

      return uploadParts;
    }()
    /**
     * Does the work of uploading a single part to its target URL.
     *
     * @param {UploadResult} uploadResult Results for the overall upload.
     * @param {InitResponseFilePart} initResponseFilePart Initialization info about the part currently being processed.
     * @param {FileTransferHandler} fileTransferHandler Will be used to provide updates
     *  on the transfer progress of a file.
     */

  }, {
    key: "processPart",
    value: function () {
      var _processPart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uploadResult, initResponseFilePart, fileTransferHandler) {
        var fileName, fileSize, partResult;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fileName = initResponseFilePart.getFileName();
                fileSize = initResponseFilePart.getFileSize(); // if a part fails or is cancelled, then the rest of the file's parts will just
                // drain out of the queue without anything happening to them

                partResult = false;
                _context2.next = 5;
                return fileTransferHandler.partTransferStarted(uploadResult, initResponseFilePart);

              case 5:
                if (!_context2.sent) {
                  _context2.next = 10;
                  break;
                }

                this.logInfo("Start uploading part for '".concat(fileName, "' to cloud, fileSize: '").concat(fileSize, "', partSize: '").concat(initResponseFilePart.getSize(), "'"));
                _context2.next = 9;
                return this.uploadPartToCloud(initResponseFilePart, fileTransferHandler);

              case 9:
                partResult = _context2.sent;

              case 10:
                _context2.next = 12;
                return fileTransferHandler.partTransferEnded(initResponseFilePart, partResult);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function processPart(_x4, _x5, _x6) {
        return _processPart.apply(this, arguments);
      }

      return processPart;
    }()
    /**
     * Performs the work of uploading a single file part to the target instance.
     *
     * @param {InitResponseFilePart} part The file part whose information will be used to do the upload.
     * @param {FileTransferHandler} fileTransferHandler Will be used to provide updates
     *  on the transfer progress of a file.
     */

  }, {
    key: "uploadPartToCloud",
    value: function () {
      var _uploadPartToCloud = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(part, fileTransferHandler) {
        var data, fileName, partRequest, partResult, response, statusCode, elapsedTime;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = part.getData();
                fileName = part.getFileName();
                partRequest = new _httpRequest.default(this.getOptions(), part.getUrl()).withMethod(_httpRequest.default.Method.PUT).withData(data, part.getSize()).withCancelId(part.getTargetFilePath()).withTimeout(this.getUploadOptions().getHttpRequestTimeout());
                partRequest.on('progress', function (progressData) {
                  fileTransferHandler.partTransferProgress(part, progressData);
                });
                partResult = new _partUploadResult.default(this.getOptions(), this.getUploadOptions(), part);
                _context3.prev = 5;
                _context3.next = 8;
                return this.httpClient.submit(partRequest, partResult);

              case 8:
                response = _context3.sent;
                statusCode = response.getStatusCode();
                elapsedTime = response.getElapsedTime();
                this.logInfo("Put upload part done for file: '".concat(fileName, "', offset: '").concat(part.getStartOffset(), "-").concat(part.getEndOffset(), "', partSize: '").concat(part.getSize(), "', spent: '").concat(elapsedTime, "' ms, status: ").concat(statusCode));
                partResult.setUploadTime(elapsedTime);
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](5);
                partResult.setError(_context3.t0);
                this.logError("Put upload part done for file: '".concat(fileName, "', offset: '").concat(part.getStartOffset(), "-").concat(part.getEndOffset(), "', partSize: '").concat(part.getSize(), "'"), _context3.t0);

              case 19:
                return _context3.abrupt("return", partResult);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 15]]);
      }));

      function uploadPartToCloud(_x7, _x8) {
        return _uploadPartToCloud.apply(this, arguments);
      }

      return uploadPartToCloud;
    }()
  }]);

  return PartUploader;
}(_uploadOptionsBase.default);

exports.default = PartUploader;